import type { AllRouteEndpoints } from "../routeTypes";

export const conversationalRouting = "/:app_group_id/conversational/routing";

export const conversationalRoutingCacheKeys: AllRouteEndpoints[] = ["/:app_group_id/conversational/routing"];
